import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { deleteProductsPermanently, restoreTrashedProducts } from './productsSlice';
const TrashedProducts = () => {
    const dispatch = useAppDispatch();
    const { trashedProducts, isProductStatLoading, isProductsRestoring } = useAppSelector((state) => state.products);
    const acceptDelete = () => {
        dispatch(deleteProductsPermanently());
    };
    const acceptRestore = () => {
        dispatch(restoreTrashedProducts());
    };
    const confirmDelete = () => {
        confirmDialog({
            message: 'Do you want to delete all the trashed products permanently?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: acceptDelete
        });
    };
    const confirmRestore = () => {
        confirmDialog({
            message: 'Do you want to restore all the trashed products?',
            header: 'Restore Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: acceptRestore
        });
    };
    const renderButtons = () => {
        if (trashedProducts) {
            let restoreButtonLabel = (isProductsRestoring) ? 'Restoring...' : 'Restore Trash';
            let productText = trashedProducts > 1 ? 'products' : 'product';
            return _jsxs("p", { children: [_jsxs("p", { children: [trashedProducts, " ", productText, " found in the trash"] }), _jsx("button", Object.assign({ className: "button-primary dap-button-danger", onClick: confirmDelete }, { children: "Delete Permanently" })), _jsx("button", Object.assign({ className: "button-primary dap-button-primary", style: { marginLeft: '10px' }, onClick: confirmRestore, disabled: isProductsRestoring }, { children: restoreButtonLabel }))] });
        }
        else if (!isProductStatLoading) {
            return _jsx("p", { children: "No products found in the trash" });
        }
        return null;
    };
    const renderLoader = () => {
        if (isProductStatLoading) {
            return _jsx("p", { children: "Loading..." });
        }
        return null;
    };
    return _jsxs(_Fragment, { children: [_jsx(ConfirmDialog, { draggable: false }), renderLoader(), renderButtons()] });
};
export default TrashedProducts;
